import { ImageLocation } from 'src/utils/URLUtils';
import styles from './ChatTitle.module.scss';
import { useTranslation } from 'react-i18next';

export default function ChatTitle() {
    const { t } = useTranslation();
    return (
        <div className={`${styles.chatTitle} guideModal`}>
            <img src={ImageLocation('Lexi/smile.png')} alt="lexi" className='lexiIcon' />
            <p>{t('Tap to view the word definition.')}</p>
        </div>
    );
} 